import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox, Col, Form, Row, Select, Typography } from 'antd';
import { searchSelectProps } from '../../constants';

import '../../../../components/Common/Form.css';

const { Text } = Typography;

const AnnouncementForm = ({
  type,
  initialValues,
  onSubmit,
  status,
  courses,
  getCourseOffers,
  courseOffers,
  trainers,
  getTrainers,
  form,
  courseOfferChangeDisabled,
}) => {
  const renderOptions = (data, valueKey, labelKey) =>
    data.map((item) => (
      <Select.Option key={item[valueKey]} value={item[valueKey]}>
        {item[labelKey]}
      </Select.Option>
    ));

  const [usePreselectedTrainer, setUsePreselectedTrainer] = useState(false);

  const toggleSelectMode = (e) => {
    setUsePreselectedTrainer(e.target.checked);
  };

  const handleSubmit = (values) => {
    const {
      courseOfferId,
      selectedLeadTrainer,
      selectedAssistantTrainer,
      selectedSupportTrainers,
      invitedTrainers,
    } = values;
    const formattedBody = { courseOfferId };

    if (usePreselectedTrainer) {
      formattedBody.selectedLeadTrainer = selectedLeadTrainer;
      formattedBody.selectedAssistantTrainer = selectedAssistantTrainer;
      formattedBody.selectedSupportTrainers = selectedSupportTrainers;
      formattedBody.preselectMode = true;
    } else {
      formattedBody.trainers = invitedTrainers || [];
    }

    onSubmit(formattedBody);
  };

  return (
    <div className="course-add-form">
      <Form
        form={form}
        labelCol={{ span: 10 }}
        onFinish={handleSubmit}
        initialValues={initialValues}
      >
        <section>
          <Form.Item
            label="Course Name"
            name="courseId"
            rules={[
              {
                required: !courseOfferChangeDisabled && true,
                message: 'Please input course name!',
              },
            ]}
          >
            <Select
              {...searchSelectProps}
              allowClear
              disabled={courseOfferChangeDisabled}
              onChange={getCourseOffers}
            >
              {renderOptions(courses, 'courseId', 'title')}
            </Select>
          </Form.Item>
          <Form.Item
            label="Course Offer Code"
            name="courseOfferId"
            rules={[
              {
                required: !courseOfferChangeDisabled && true,
                message: 'Please input course offer code!',
              },
            ]}
          >
            <Select
              {...searchSelectProps}
              allowClear
              onChange={getTrainers}
              disabled={courseOfferChangeDisabled}
            >
              {renderOptions(courseOffers, 'courseOfferId', 'code')}
            </Select>
          </Form.Item>
          <Form.Item
            label="Use Preselected Trainer"
            name="usePreselectedTrainer"
          >
            <Checkbox
              checked={usePreselectedTrainer}
              onChange={toggleSelectMode}
              // TODO: add disabled prop --> true if wave not selected
            />
          </Form.Item>
          <Form.Item
            label="Lead Trainer"
            name="selectedLeadTrainer"
            rules={[
              {
                required: usePreselectedTrainer,
                message: 'Please select trainer!',
              },
            ]}
          >
            <Select
              {...searchSelectProps}
              allowClear
              disabled={!usePreselectedTrainer} // TODO: true if wave not selected
            >
              {renderOptions(trainers, 'id', 'name')}
            </Select>
          </Form.Item>
          <Form.Item
            label="Assistant Trainer"
            name="selectedAssistantTrainer"
            rules={[
              {
                required: usePreselectedTrainer,
                message: 'Please select trainer!',
              },
            ]}
          >
            <Select
              {...searchSelectProps}
              allowClear
              disabled={!usePreselectedTrainer} // TODO: true if wave not selected
            >
              {renderOptions(trainers, 'id', 'name')}
            </Select>
          </Form.Item>
          <Form.Item label="Support Trainers" name="selectedSupportTrainers">
            <Select
              mode="multiple"
              {...searchSelectProps}
              allowClear
              disabled={!usePreselectedTrainer} // TODO: true if wave not selected
            >
              {renderOptions(trainers, 'id', 'name')}
            </Select>
          </Form.Item>
          <Form.Item label="Invite Trainers" name="invitedTrainers">
            <Select
              mode="multiple"
              {...searchSelectProps}
              allowClear
              disabled={usePreselectedTrainer} // TODO: true if wave not selected
            >
              {renderOptions(trainers, 'id', 'name')}
            </Select>
          </Form.Item>
        </section>

        {status.type === 'ERROR' && <Text type="danger">{status.message}</Text>}
        <br />

        <Row justify="end" gutter={12}>
          <Col>
            <Button type="primary" htmlType="submit">
              {type}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

AnnouncementForm.propTypes = {
  trainers: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  getTrainers: PropTypes.func,
  form: PropTypes.any,
  status: PropTypes.shape({
    message: PropTypes.string,
    error: PropTypes.string,
    type: PropTypes.string,
  }),
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  type: PropTypes.string,
  courseOffers: PropTypes.array,
  getCourseOffers: PropTypes.func,
  courseOfferChangeDisabled: PropTypes.bool,
};

export default AnnouncementForm;
